// extracted by mini-css-extract-plugin
module.exports = {"events-root":"styles_events-root__2tSLs","btn":"styles_btn__acRfw","img__wrapper":"styles_img__wrapper__1TTyO"};